/**
 * Labstep
 *
 * @module components/Experiment/Form/ShowEdit/State/ButtonEdit
 * @desc Button to switch to edit mode
 */

import { ExperimentFormShowEditStateExperimentActionEdit } from 'labstep-web/components/Experiment/Form/ShowEdit/State/ExperimentActionEdit';
import { ExperimentWorkflowActionUpdateStatus as ExperimentWorkflowActionUpdateEntityState } from 'labstep-web/components/ExperimentWorkflow/Action/UpdateEntityState';
import type React from 'react';
import styles from './styles.module.scss';
import type { ExperimentFormShowEditStateButtonEditProps } from './types';

export const ExperimentFormShowEditStateButtonEdit: React.FC<
  ExperimentFormShowEditStateButtonEditProps
> = ({ experimentWorkflow, experiment, onClick }) => (
  <div className={styles.container}>
    <ExperimentFormShowEditStateExperimentActionEdit
      experiment={experiment}
      actionComponentProps={{
        dataCy:
          'components/Experiment/Form/ShowEdit/State/ButtonEdit',
        type: 'button',
        icon: 'pencil',
        showIcon: true,
        elementProps: { color: undefined, basic: true },
      }}
      onClick={onClick}
    />

    {experimentWorkflow && (
      <ExperimentWorkflowActionUpdateEntityState
        experimentWorkflow={experimentWorkflow}
      />
    )}
  </div>
);
